import {SET_PERFORMANCES} from './../actions';

const performances = (state = [], action) => {
  switch (action.type) {
    case SET_PERFORMANCES:
      return action.data;
    default:
      return state;
  }
};

export default performances;




/** WEBPACK FOOTER **
 ** ./src/reducers/performances.reducer.js
 **/